import React from "react";
import { connect } from "react-redux";
import Select from 'react-select';

import "./EditSupervisors.css"

import { getAllUsers } from "../../../../../actions/userActions";
import { setOuName, getOuName, getOuSupervisors, editOuSupervisors } from "../../../../../actions/structureActions";

class EditSupervisors extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            addOperations: {},
            updateOperations: {},
            deleteOperations: {},
            changeErrors: []
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getAllUsers();
        this.props.getOuName(this.props.match.params.ouID);
        this.props.getOuSupervisors(this.props.match.params.ouID);
    }

    onRowUpdate = (supervisor, value, field, isNew) => {
        if (isNew) this.setState({ addOperations: { ...this.state.addOperations,
            [supervisor.userID]: { ...this.state.addOperations[supervisor.userID], [field]: value }
        } });
        else this.setState({ updateOperations: { ...this.state.updateOperations,
            [supervisor.supervisorID]: this.state.updateOperations[supervisor.supervisorID] ? (
                JSON.stringify({ ...this.state.updateOperations[supervisor.supervisorID], [field]: value }) !== JSON.stringify(supervisor) ?
                { ...this.state.updateOperations[supervisor.supervisorID], [field]: value } : null
            ) : { ...supervisor, [field]: value }
        } });
    };

    onNewChange = (userID, value) => {
        if (!this.props.supervisors.find(s => s.userID === value.value.userID)) {
            if (userID !== null) this.setState({ addOperations: { ...this.state.addOperations, [userID]: null, [value.value.userID]: value.value } });
            else this.setState({ addOperations: { ...this.state.addOperations, [value.value.userID]: value.value } });
        }
    }

    onRowDelete = (supervisor) => {
        this.setState({ deleteOperations: { ...this.state.deleteOperations, [supervisor.supervisorID]: this.state.deleteOperations[supervisor.supervisorID] ? null : supervisor } });
    };

    onNewDelete = (userID) => {
        this.setState({ addOperations: { ...this.state.addOperations, [userID]: null } });
    };

    onChangesApply = () => {
        const formValues = {
            addOperations: [...Object.keys(this.state.addOperations).map(key => this.state.addOperations[key] ? {
                userID: this.state.addOperations[key].userID, priority: this.state.addOperations[key].priority, dateFrom: this.state.addOperations[key].dateFrom, dateTo: this.state.addOperations[key].dateTo
            } : null).filter(v => v !== null)],
            updateOperations: [...Object.keys(this.state.updateOperations).map(key => (this.state.updateOperations[key] && !this.state.deleteOperations[key]) ? {
                supervisorID: this.state.updateOperations[key].supervisorID, priority: this.state.updateOperations[key].priority, dateFrom: this.state.updateOperations[key].dateFrom, dateTo: this.state.updateOperations[key].dateTo
            } : null).filter(v => v !== null)],
            deleteOperations: [...Object.keys(this.state.deleteOperations).map(key => this.state.deleteOperations[key] ? this.state.deleteOperations[key].supervisorID : null).filter(v => v !== null)]
        };
        this.props.editOuSupervisors(this.props.match.params.ouID, formValues, this.onChangeSuccess, this.onChangeError);
    };

    onChangeSuccess = () => this.setState(this.initialState);

    onChangeError = ({ data }) => this.setState({ changeErrors: data.error });

    renderError = error => {
        return error ? (
            <div className="ui error message">
                {error.message.map((line, index) => <p key={index}>{line}</p>)}
            </div>
        ) : null;
    }

    renderRows = () => this.props.supervisors.map(supervisor => {
        return (
            <div key={supervisor.supervisorID} className={`ui ${this.state.deleteOperations[supervisor.supervisorID] ? "secondary red " : this.state.updateOperations[supervisor.supervisorID] ? "secondary yellow " : ""}segment`}>
                {this.renderRow(supervisor, false)}
            </div>
        );
    });

    renderNewRows = () => Object.keys(this.state.addOperations).map(key => {
        return (this.state.addOperations[key] ? (
            <div key={key} className="ui secondary green segment">
                {this.renderRow(this.state.addOperations[key], true)}
            </div>
        ) : <React.Fragment key={key} />);
    });

    renderRow = (supervisor, isNew) => {
        let rowErrors = {};
        if (supervisor) {
            rowErrors = {
                priority: this.state.changeErrors.filter(err => err.field === "priority" && ((isNew && err.userID === supervisor.userID) || (!isNew && err.supervisorID === supervisor.supervisorID)))[0],
                dateFrom: this.state.changeErrors.filter(err => err.field === "dateFrom" && ((isNew && err.userID === supervisor.userID) || (!isNew && err.supervisorID === supervisor.supervisorID)))[0],
                dateTo: this.state.changeErrors.filter(err => err.field === "dateTo" && ((isNew && err.userID === supervisor.userID) || (!isNew && err.supervisorID === supervisor.supervisorID)))[0]
            };
        }

        return (
            <div className={`ui ${supervisor ? "" : "header "}grid`}>
                {supervisor && isNew ? (
                    <div className="row">
                        <div className="four wide normal overflow column">
                            <Select
                                value={{ label: `${supervisor.lname} ${supervisor.fname}`, value: supervisor.userID }}
                                onChange={value => this.onNewChange(supervisor.userID, value)}
                                options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: { ...u, supervisorID: null, priority: 1, dateFrom: "", dateTo: "" } } })]}
                                placeholder="Użytkownik"
                                noOptionsMessage={() => "Nie znaleziono użytkowników"}
                                maxMenuHeight="400px"
                            />
                        </div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="four wide column">
                        <div className="content">{supervisor ? supervisor.userID : "Numer ewidencyjny"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{supervisor ? `${supervisor.lname} ${supervisor.fname}` : "Nazwisko i imię"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{supervisor ? supervisor.email : "Email"}</div>
                    </div>
                    <div className="four wide overflow column">
                        {supervisor ? (
                            <button className="ui button" onClick={() => isNew ? this.onNewDelete(supervisor.userID) : this.onRowDelete(supervisor)}>{isNew ? "Anuluj" : this.state.deleteOperations[supervisor.supervisorID] ? "Cofnij" : "Usuń"}</button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="four wide column">
                        <div className="content">{supervisor ? supervisor.supervisorID : "Numer przełożonego"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{supervisor ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[supervisor.supervisorID] !== null && this.state.deleteOperations[supervisor.supervisorID] !== undefined}
                                    type="number"
                                    value={
                                        isNew ? this.state.addOperations[supervisor.userID].priority :
                                        this.state.updateOperations[supervisor.supervisorID] ? this.state.updateOperations[supervisor.supervisorID].priority : supervisor.priority
                                    }
                                    onChange={value => this.onRowUpdate(supervisor, +value.target.value, "priority", isNew)}
                                />
                                {this.renderError(rowErrors.priority)}
                            </div>
                        ) : "Priorytet"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{supervisor ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[supervisor.supervisorID] !== null && this.state.deleteOperations[supervisor.supervisorID] !== undefined}
                                    type="date"
                                    value={
                                        isNew ? this.state.addOperations[supervisor.userID].dateFrom :
                                        this.state.updateOperations[supervisor.supervisorID] ? this.state.updateOperations[supervisor.supervisorID].dateFrom : supervisor.dateFrom
                                    }
                                    onChange={value => this.onRowUpdate(supervisor, value.target.value, "dateFrom", isNew)}
                                />
                                {this.renderError(rowErrors.dateFrom)}
                            </div>
                        ) : "Od dnia"}</div>
                    </div>
                    <div className="four wide column">
                        <div className="content">{supervisor ? (
                            <div className="ui form error warning">
                                <input
                                    disabled={this.state.deleteOperations[supervisor.supervisorID] !== null && this.state.deleteOperations[supervisor.supervisorID] !== undefined}
                                    type="date"
                                    value={
                                        isNew ? this.state.addOperations[supervisor.userID].dateTo :
                                        this.state.updateOperations[supervisor.supervisorID] ? this.state.updateOperations[supervisor.supervisorID].dateTo : supervisor.dateTo
                                    }
                                    onChange={value => this.onRowUpdate(supervisor, value.target.value, "dateTo", isNew)}
                                />
                                {this.renderError(rowErrors.dateTo)}
                            </div>
                        ) : "Do dnia"}</div>
                    </div>
                </div>
            </div>
        )
    };

    renderChanges = () => {
        const changes = [
            ...Object.keys(this.state.addOperations).map(key => this.renderChange(this.state.addOperations[key], key, "add")),
            ...Object.keys(this.state.updateOperations).map(key => this.renderChange(this.state.updateOperations[key], key, "update")),
            ...Object.keys(this.state.deleteOperations).map(key => this.renderChange(this.state.deleteOperations[key], key, "delete"))
        ].filter(v => v !== null);

        return changes.length ? (
            <React.Fragment>
                <div className="ui divider" />
                <div className="ui secondary blue segment">
                    <div className="ui header">
                        <div className="content">Wykaz zmian</div>
                    </div>
                    {changes}
                </div>
                <button className="ui primary button" onClick={this.onChangesApply}>Zatwierdź</button>
                <button className="ui button" onClick={() => this.setState(this.initialState)}>Anuluj</button>
            </React.Fragment>
        ) : null;
    };

    renderChange = (operation, key, type) => {
        return (operation && (type !== "update" || (type === "update" && !this.state.deleteOperations[key]))) ? (
            <div key={`${type}${operation.userID}`} className={`${type === "add" ? "green" : type === "update" ? "yellow" : "red"} content`}>
                {type === "add" ? "Dodano" : type === "update" ? "Zmodyfikowano" : "Usunięto"} rolę przełożonego jednostki <b>{this.props.ouName}</b>&nbsp;
                użytkownikowi <b>{operation.lname} {operation.fname}</b>
            </div>
        ) : null;
    };

    render() {
        return (
            <React.Fragment>
                <div className="edit-supervisors-component ui container">
                    <div className="ui container">
                        <div className="ui header">
                            <div className="content">Przełożeni jednostki: {this.props.ouName}</div>
                        </div>
                        <div className="ui divider" />
                        {this.props.supervisors.length ? (
                            <React.Fragment>
                                {this.renderRow()}
                                {this.renderRows()}
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="ui small header">
                                    <div className="content">Brak przełożonych jednostki</div>
                                </div>
                                <div className="ui divider" />
                            </React.Fragment>
                        )}
                        {Object.keys(this.state.addOperations).find(key => this.state.addOperations[key]) ? this.renderRow(null, true) : null}
                        {this.renderNewRows()}
                        <Select
                            value={{ label: "Dodaj...", value: null }}
                            onChange={value => this.onNewChange(null, value)}
                            options={[...this.props.usersList.map(u => { return { label: `${u.lname} ${u.fname}`, value: { ...u, supervisorID: null, priority: 1, dateFrom: "", dateTo: "" } } })]}
                            placeholder="Użytkownik"
                            noOptionsMessage={() => "Nie znaleziono użytkowników"}
                            maxMenuHeight="400px"
                        />
                        {this.renderChanges()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    usersList: state.user.list,
    ouName: state.structure.edit.name,
    supervisors: state.structure.edit.supervisors
});

export default connect(mapStateToProps, { getAllUsers, setOuName, getOuName, getOuSupervisors, editOuSupervisors })(EditSupervisors);